import { customBaseQuery } from '@/lib/baseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';

export const dashboardAPI = createApi({
  reducerPath: 'dashboardAPI',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    fetchAdminDashboardData: builder.query<any, void>({
      query: () => '/v1/online-assessment/dashboard',
    }),
    fetchDashboardStats: builder.query<
      any,
      { limit: number; startDate: string; endDate: string }
    >({
      query: ({ limit, startDate, endDate }) => {
        return {
          url: '/documents/dashboard-stats',
          method: 'GET',
          params: { limit, startDate, endDate },
        };
      },
    }),
  }),
});

export const { useFetchAdminDashboardDataQuery, useFetchDashboardStatsQuery } =
  dashboardAPI;
